"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import type { UserCouponWithTemplate } from "../schema";
import { CouponCard, type CouponCardProps } from "./coupon-card";
export interface CouponListProps {
  coupons: UserCouponWithTemplate[];
  layout?: "list";
  variant?: CouponCardProps["variant"];
  className?: string;
  emptyState?: ReactNode;
  loading?: boolean;
  loadingState?: ReactNode;
  onShopNow?: CouponCardProps["onShopNow"];
  onSelect?: CouponCardProps["onSelect"];
  showActions?: boolean;
  showRules?: boolean;
  cartSubtotal?: number; // For minimum order validation in checkout context
  isFromHistoryTab?: boolean; // Whether this coupon list is from the history/expired tab
}

/**
 * Unified Coupon List Component
 * Handles different layouts and states for coupon collections
 */
export const CouponList: React.FC<CouponListProps> = t0 => {
  const $ = _c(31);
  const {
    coupons,
    layout,
    variant: t1,
    className,
    emptyState,
    loading: t2,
    loadingState,
    onShopNow,
    onSelect,
    showActions: t3,
    showRules: t4,
    cartSubtotal,
    isFromHistoryTab: t5
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const loading = t2 === undefined ? false : t2;
  const showActions = t3 === undefined ? true : t3;
  const showRules = t4 === undefined ? true : t4;
  const isFromHistoryTab = t5 === undefined ? false : t5;
  if (loading) {
    let t6;
    if ($[0] !== loadingState) {
      t6 = loadingState || <div className="flex items-center justify-center py-8"><div className="text-gray-500">Loading coupons...</div></div>;
      $[0] = loadingState;
      $[1] = t6;
    } else {
      t6 = $[1];
    }
    return t6;
  }
  if (!coupons || coupons.length === 0) {
    let t6;
    if ($[2] !== emptyState) {
      t6 = emptyState || <div className="flex items-center justify-center py-8"><div className="text-gray-500">No coupons available</div></div>;
      $[2] = emptyState;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    return t6;
  }
  let t6;
  if ($[4] !== layout) {
    t6 = () => {
      switch (layout) {
        case "list":
          {
            return "flex flex-col gap-6";
          }
        default:
          {
            return "grid grid-cols-1 gap-4 md:grid-cols-2";
          }
      }
    };
    $[4] = layout;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const getLayoutClasses = t6;
  let t7;
  if ($[6] !== variant) {
    t7 = () => {
      if (variant !== "default") {
        return variant;
      }
      return "default";
    };
    $[6] = variant;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const getCardVariant = t7;
  let t8;
  if ($[8] !== className || $[9] !== getLayoutClasses) {
    t8 = cn(getLayoutClasses(), className);
    $[8] = className;
    $[9] = getLayoutClasses;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== cartSubtotal || $[12] !== coupons || $[13] !== getCardVariant || $[14] !== isFromHistoryTab || $[15] !== onSelect || $[16] !== onShopNow || $[17] !== showActions || $[18] !== showRules) {
    let t10;
    if ($[20] !== cartSubtotal || $[21] !== getCardVariant || $[22] !== isFromHistoryTab || $[23] !== onSelect || $[24] !== onShopNow || $[25] !== showActions || $[26] !== showRules) {
      t10 = coupon => <CouponCard key={coupon.id} coupon={coupon} variant={getCardVariant()} onShopNow={onShopNow} onSelect={onSelect} showActions={showActions} showRules={showRules} cartSubtotal={cartSubtotal} isFromHistoryTab={isFromHistoryTab} />;
      $[20] = cartSubtotal;
      $[21] = getCardVariant;
      $[22] = isFromHistoryTab;
      $[23] = onSelect;
      $[24] = onShopNow;
      $[25] = showActions;
      $[26] = showRules;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    t9 = coupons.map(t10);
    $[11] = cartSubtotal;
    $[12] = coupons;
    $[13] = getCardVariant;
    $[14] = isFromHistoryTab;
    $[15] = onSelect;
    $[16] = onShopNow;
    $[17] = showActions;
    $[18] = showRules;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
export default CouponList;